import request from '@/utils/request'

export function getClientList(data) {
  return request.post('/client/list', data)
}

export function getClientDictList(data) {
  return request.post('/client/dict', data)
}

export function getHospital(){
  return request.post('/client-hospital/wx-getList', data)
}





// WEBPACK FOOTER //
// ./src/api/client.js